export default "__VITE_ASSET__BspHMhp4__"